import { DetailCard } from 'xui-pro';
import { data, globalData } from '../../../models/notificationData';
import { List } from 'antd';
import styles from './index.module.less';
import { useCallback } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import type { RootState } from '@/models/store';
import { useTranslation } from '@/hooks/useTranslation'; // 引入useTranslation钩子

export default () => {
  const $ = useTranslation(); // 初始化useTranslation钩子
  const onClick = useCallback((item: { id: number; title: string }) => {
    window.xDragonBridge.openNewTab({
      path: `/afs-sip/repair-info-search/notice/${item.id}`,
      title: item.title
    });
  }, []);

  const isGlobal = useSelector<RootState>(state => state.LocaleModel.isGlobal, shallowEqual);

  return (
    <DetailCard title={$('SysteamNotification')} className={styles['card']}>
      <List
        dataSource={isGlobal ? globalData : data}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta title={<a onClick={() => onClick(item)}>{item.title}</a>} />
            <div>{item.time}</div>
          </List.Item>
        )}
      />
    </DetailCard>
  );
};
